import { h } from 'preact';
import { OutfitSlider } from './OutfitSlider';
const defaultLayout = {
    cardLayout: 'gridFour',
    filterLayout: 'filterTop',
};
export function PinnedSection({ section, title = 'Featured Block', description, ctaText, ctaLink = '#', layout = 'gridFour', collectionId, }) {
    const layoutFull = Object.assign(Object.assign({}, defaultLayout), { cardLayout: layout });
    const hasItems = section.products.length > 0;
    if (!hasItems)
        return null;
    // TODO: Update pinned section to support different section types (products, outfits, videos, banners, etc.)
    return (h(OutfitSlider, { products: section.products, layout: layoutFull, useCollectionMetafieldHeading: true, collectionId: collectionId }));
}
